export const sortArrayHacksawGames = [
  '1511',
  '1537',
  '1116',
  '1175',
  '1312',
  '1623',
  '1236',
  '1411',
  '1250',
  '1246',
  '1565',
  '1167',
  '1351',
  '1317',
  '1533',
  '1212',
  '1402',
  '1485',
  '1399',
  '1355',
  '1553',
  '1569',
  '1121',
  '1446',
  '1669',
];
